export default "__VITE_PUBLIC_ASSET__cc4580ce__"